import React from 'react';
import { Avatar } from '../common/Avatar';
import { teamLabel } from '../../utils/teams';
import type { FloorSnapshot } from '../../utils/floor';
interface PacesetterListProps {
  snapshot: FloorSnapshot;
  dateLabel: string;
  onSelect: (id: string) => void;
}
export function PacesetterList({
  snapshot,
  dateLabel,
  onSelect
}: PacesetterListProps) {
  const pacesetters = (snapshot.tiers.find(t => t.tier.id === 'pacesetter')?.rows ?? []).slice(0, 5);
  return <section aria-labelledby="pacesetters-heading" className="flex h-full flex-col rounded-2xl border border-line bg-surface p-6 shadow-card" data-id="element-158" data-mp="2q90byfqpgi6t">
      <h2 id="pacesetters-heading" className="text-base font-semibold text-ink" data-id="element-159" data-mp="2bapuqbfq8ndb">
        Top 5 Pacesetters
      </h2>
      <p className="mt-0.5 text-sm text-muted" data-id="element-160" data-mp="2g99huf624579">Production score 75+ · {dateLabel}</p>
      {pacesetters.length === 0 ? <p className="py-8 text-center text-sm text-muted" data-id="element-161" data-mp="zyoxe84srqly">No Pacesetters this day.</p> : <ol className="-mx-2 mt-3 divide-y divide-line" data-id="element-162" data-mp="14tkw1r4jhc81">
          {pacesetters.map((r, i) => <li key={r.agent.id} data-id="element-163" data-mp="12yxbtrd5buaj" data-mpi={i}>
              <button type="button" onClick={() => onSelect(r.agent.id)} aria-label={`${i + 1}. ${r.agent.name}, score ${r.score}. View details`} className="flex w-full items-center gap-3 rounded-lg px-2 py-2.5 text-left transition-colors duration-150 ease-out hover:bg-canvas focus:outline-none focus-visible:bg-canvas" data-id="element-164" data-mp="xy9i2xxj8zcm">
                <span className="w-4 shrink-0 text-xs font-semibold text-subtle" data-id="element-165" data-mp="1gx40cgw7ghxj">{i + 1}</span>
                <Avatar name={r.agent.name} size="sm" data-id="element-166" data-mp="1uoiiymm7ah42" />
                <span className="min-w-0 flex-1" data-id="element-167" data-mp="1uq3dic8im01x">
                  <span className="block truncate text-sm font-semibold text-ink" data-id="element-168" data-mp="1qm5ctx3jkh6r">{r.agent.name}</span>
                  <span className="block truncate text-xs text-muted" data-id="element-169" data-mp="24ldi97qaslje">
                    {teamLabel(r.agent.team)} · {r.day.leads} leads · {r.day.loans} loans
                  </span>
                </span>
                <span className="shrink-0 text-right" data-id="element-170" data-mp="xap446hood2r">
                  <span className="block font-display text-lg font-bold leading-none text-positive" data-id="element-171" data-mp="11b92fddztmqh">{r.score}</span>
                  <span className="text-[11px] text-subtle" data-id="element-172" data-mp="16alwai3a7u2k">score</span>
                </span>
              </button>
            </li>)}
        </ol>}
    </section>;
}